import { render } from "./Misconduct_Admin.vue?vue&type=template&id=f04bc6be&scoped=true"
import script from "./Misconduct_Admin.vue?vue&type=script&lang=js"
export * from "./Misconduct_Admin.vue?vue&type=script&lang=js"

import "./Misconduct_Admin.vue?vue&type=style&index=0&id=f04bc6be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04bc6be"]])

export default __exports__